import React, { useEffect } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './ReviewConfirmation.module.scss'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import * as Data from 'shared/const/data.js'
import moment from 'moment-timezone'

const RoadTestInfo = ({ t, i18n, setIsError }) => {
    let history = useHistory()
    const timezone = process.env.REACT_APP_TIME_ZONE.toString()
    moment.tz.setDefault(timezone)

    const typeRoadTest = useSelector((state) => state.driver.driverInformation.typeRoadTest)
    const masterNumber = useSelector((state) => state.driver.driverInformation.masterNumber)
    const driverFirstName = useSelector((state) => state.driver.driverInformation.driverFirstName)
    const driverLastName = useSelector((state) => state.driver.driverInformation.driverLastName)
    const dateOfBirth = useSelector((state) => state.driver.driverInformation.dateOfBirth)
    const emailAddress = useSelector((state) => state.driver.driverInformation.emailAddress)
    const phoneNumber = useSelector((state) => state.driver.driverInformation.phoneNumber)

    useEffect(() => {
        try {
            if (
                typeRoadTest === 'select' ||
                masterNumber === '' ||
                driverFirstName === '' ||
                driverLastName === '' ||
                dateOfBirth === '' ||
                emailAddress === '' ||
                phoneNumber === ''
            ) {
                history.push(`/${i18n.language}${t('routes.school_question')}`)
            }
        } catch (e) {
            console.log(e)
            setIsError(true)
        }
    }, [])

    const checkNull = (val) => {
        return val === '' ? 'null' : val
    }

    const editDrivingSchoolOnClick = () => {
        history.push(`/${i18n.language}${t('routes.driver_info')}`)
    }

    const getDateOfBirthFormat = (date) => {
        return moment(date).format('MMMM DD, YYYY')
    }

    const getAmountString = (num) => {
        try {
            return i18n.language === 'en' ? `$ ${num}` : `${num.toString().replace('.', ',')} $`
        } catch (e) {
            console.log(e)
        }
    }

    return (
        <React.Fragment>
            <div className={['row', styles['display_flex']].join(' ')}>
                <div className="col-xs-12 col-md-5 col-sm-7 col-lg-5">
                    <strong className={styles['margin_bottom']}>{t('review_confirmation.type_road_test')}</strong>
                </div>
                <div className="col-xs-12 col-md-7 col-sm-7 col-lg-7">
                    <p className={styles['margin_bottom']}>{checkNull(Data['roadTestTypes'][typeRoadTest][i18n.language])}</p>
                </div>
            </div>
        </React.Fragment>
    )
}

export default withTranslation('common')(RoadTestInfo)
